import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/**
 * 削除中の勤務を画面から先に消す。
 *
 * 削除は API の応答まで 1〜数秒かかる。その間カードが残っていると「押しても消えない」
 * ように見えるので、押した時点で消す。失敗したら呼び出し側が集合から外し、
 * 次の描画で戻る（サーバの値を書き換えないので復活は取り直し不要）。
 *
 * 勤務を持たない行（「回転を追加」の仮想行）は巻き添えにしない。
 */
export function hideDeletingShifts(
  groups: VehicleRowGroup[],
  deletingShiftTruckIds: ReadonlySet<number>,
): VehicleRowGroup[] {
  if (deletingShiftTruckIds.size === 0) return groups;

  const next: VehicleRowGroup[] = [];
  let changed = false;
  groups.forEach((group) => {
    const rows = group.rows.filter(
      (row) => row.shiftTruckId == null || !deletingShiftTruckIds.has(row.shiftTruckId),
    );
    if (rows.length === group.rows.length) {
      next.push(group);
      return;
    }
    changed = true;
    // 勤務ごとにグループが分かれるので、全行消えたグループはカードごと消す
    if (rows.length > 0) next.push({ ...group, rows });
  });

  // 参照が変わると memo 済みの車両リストが毎回再描画される
  return changed ? next : groups;
}
